import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  Divider,
  FormControlLabel,
  Grid,
  InputBase,
  LinearProgress,
  linearProgressClasses,
  Radio,
  RadioGroup,
  styled,
  SvgIcon,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BACK_ICON, PROGRESS_STAR } from '../../utils/imageUrls';
import {
  colorDisableGrey,
  colorLinkGrey,
  colorPrimary,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import { useNavigate } from 'react-router-dom';
import { IOSSwitch } from '../../utils/styledLayout';
import { getContentById } from '../../redux/reducers/contentSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
  getAllContentBySection,
  getFavouriteListAll,
  getLibraryListAll,
  revertResources,
  updateAutoPlayStatus
} from '../../redux/reducers/resourcesSlice';
import { getUserList } from '../../redux/reducers/usersSlice';
import QuestionCompleteModal from './components/QuestionCompleteModal';
import FlashcardImageModal from './components/FlashcardImageModal';
import {
  getBasicDetails,
  getIsAutoPlayStatus,
  setIsAutoPlayStatus
} from '../../config/cookie';
import _ from 'lodash';
import ContentCard from './ContentCard';
import { getGamificationPoints } from '../../redux/reducers/layoutSlice';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800]
    })
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: colorPrimary,
    ...theme.applyStyles('dark', {
      backgroundColor: colorPrimary
    })
  }
}));

const circleStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '44px',
  height: '44px',
  borderRadius: '50%',
  backgroundColor: '#c9c9c9',
  color: 'white',
  fontSize: '18px',
  marginRight: '5px'
};

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto'
  }
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  // padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  right: 6,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

let searchValue = '';
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  height: '2rem',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 1.5),
    paddingRight: `calc(1em + ${theme.spacing(2)})`,
    transition: theme.transitions.create('width'),
    width: searchValue ? '15ch' : '0px',
    border: searchValue && '1px solid #CBD2D9',
    borderRadius: searchValue && '8px',
    [theme.breakpoints.up('sm')]: {
      '&:focus': {
        width: searchValue ? '15ch' : '15ch',
        border: '1px solid #CBD2D9',
        borderRadius: '8px'
      }
    }
  }
}));

const FlashCardView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { authData } = useSelector(state => state.auth);
  const { contentDetails, isGetContentSuccess, isGetContentLoading } =
    useSelector(state => state.content);
  const {
    isSaveToWatchLaterSuccess,
    isSectionWiseContentSuccess,
    libraryListAll,
    isGetFavouriteListAllSuccess,
    favouriteListAll,
    sectionWiseContentList,
    isGetLibraryListAllSuccess,
    isSectionWiseContentLoading,
    isUpdateLikeDislikeSuccess,
    isUpdateLikeDislikeLoading
  } = useSelector(state => state.resource);

  const urlParams = new URLSearchParams(location.search);
  const encryptId = urlParams.get('id');
  const sectionId = urlParams.get('sectionId');
  const tags = location?.state?.tags || [];
  const path = location?.state?.path || '';
  const userId = authData?.userId || 0;
  const userName = authData?.userName || '';

  const [viewContent, setViewContent] = useState();
  const [isShowHint, setIsShowHint] = useState(false);
  const [questionNo, setQuestionNo] = useState(1);
  const [time, setTime] = useState(120);
  const [encryptIds, setEncryptIds] = useState([encryptId]);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const [contentList, setContentList] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [questionOptions, setQuestionOptions] = useState({
    1: [],
    2: [],
    3: [],
    4: [],
    5: []
  });
  const [answerOptions, setAnswerOptions] = useState({
    1: [],
    2: [],
    3: [],
    4: [],
    5: []
  });

  const [isAnswerGivenList, setIsAnswerGivenList] = useState({});

  const [radioValue, setRadioValue] = useState('');

  // Remaining questions

  const [percentageRemaining, setPercentageRemaining] = useState(0);
  const [questionsRemaining, setQuestionsRemaining] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [isCompleteQuestion, setIsCompleteQuestion] = useState(false);
  const [imageModalOpen, setIsImageModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isCompleteModalDisplay, setIsCompleteModalDisplay] = useState(false);
  const countTrueValues =
    Object.keys(isAnswerGivenList).length > 0
      ? Object.values(isAnswerGivenList).filter(value => value === true).length
      : 0;

  const totalQuestions = contentDetails?.flashCard.length || 0;
  const remainingQuestions = totalQuestions - countTrueValues;

  const remainingPercentage = (countTrueValues / totalQuestions) * 100;

  // End
  const autoPlay = getIsAutoPlayStatus();
  const basicDetails = JSON.parse(getBasicDetails());

  useEffect(() => {
    if (autoPlay) {
      setIsAutoPlay(autoPlay?.autoPlayStatus);
    }
  }, []);

  useEffect(() => {
    if (sectionWiseContentList && isSectionWiseContentSuccess) {
      setContentList(sectionWiseContentList?.payload?.dataList || []);
    } else if (libraryListAll?.contentList && isGetLibraryListAllSuccess) {
      setContentList(libraryListAll?.contentList || []);
    } else if (favouriteListAll?.contentList && isGetFavouriteListAllSuccess) {
      setContentList(favouriteListAll?.contentList || []);
    }
  }, [
    sectionWiseContentList,
    isSectionWiseContentSuccess,
    libraryListAll,
    isGetLibraryListAllSuccess,
    isGetFavouriteListAllSuccess
  ]);

  const convertToSeconds = timeStr => {
    const [minutes, seconds] = timeStr.split(':').map(Number);
    return minutes * 60 + seconds;
  };

  useEffect(() => {
    if (encryptId) {
      dispatch(getContentById({ encryptId, userId }));
      dispatch(
        getUserList({
          payload: { page: 0, size: 0, search: '', type: 'all' }
        })
      );
      dispatch(revertResources());
    }
  }, [encryptId]);

  useEffect(() => {
    if (contentDetails && isGetContentSuccess) {
      setViewContent(contentDetails);
      setQuestionOptions(prevOptions => ({
        ...prevOptions,
        [questionNo]: contentDetails?.flashCard[0]?.optionRequests || []
      }));
      const timeString =
        contentDetails?.flashCard[0]?.time == '00:00'
          ? '59:59'
          : contentDetails?.flashCard[0]?.time || '00:00';
      setTime(convertToSeconds(timeString));

      const questionLength = contentDetails?.flashCard.length || 0;

      const initialState = {};
      for (let i = 1; i <= questionLength; i++) {
        initialState[i] = false;
      }
      setIsAnswerGivenList(initialState);
      setQuestionsRemaining(questionLength);
    }
  }, [contentDetails, isGetContentSuccess]);

  // For Timing

  useEffect(() => {
    if (time === 0) {
      setIsAnswerGivenList(prevOptions => ({
        ...prevOptions,
        [questionNo]: true
      }));

      setAnswerOptions(prevOptions => ({
        ...prevOptions,
        [questionNo]: prevOptions[questionNo] || [
          { optionText: null, isAnswer: 1 }
        ]
      }));
      return;
    }

    const timerId = setInterval(() => {
      setTime(prevTime => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [time]);

  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`;
  };

  const handleQuestionNo = method => {
    setIsPopupOpen(false);
    if (method == 'back') {
      if (questionNo != 1) {
        let tempQuestionNo = questionNo - 1;

        setQuestionNo(tempQuestionNo);

        setQuestionOptions(prevOptions => ({
          ...prevOptions,
          [tempQuestionNo]:
            contentDetails?.flashCard[tempQuestionNo - 1]?.optionRequests || []
        }));
        const timeString =
          contentDetails?.flashCard[tempQuestionNo - 1]?.time == '00:00'
            ? '59:59'
            : contentDetails?.flashCard[tempQuestionNo - 1]?.time || '';
        setTime(convertToSeconds(timeString));
      }
    } else {
      setIsFlipped(false);
      setPercentageRemaining(remainingPercentage);
      setQuestionsRemaining(remainingQuestions);

      if (isAnswerGivenList[questionNo]) {
        if (questionNo - 1 !== viewContent?.flashCard.length - 1) {
          let tempQuestionNo = questionNo + 1;

          setQuestionNo(tempQuestionNo);
          setQuestionOptions(prevOptions => ({
            ...prevOptions,
            [tempQuestionNo]:
              contentDetails?.flashCard[tempQuestionNo - 1]?.optionRequests ||
              []
          }));
          const timeString =
            contentDetails?.flashCard[tempQuestionNo - 1]?.time == '00:00'
              ? '59:59'
              : contentDetails?.flashCard[tempQuestionNo - 1]?.time || '';
          setTime(convertToSeconds(timeString));
        } else {
          setIsCompleteModalDisplay(true);
          if (!isCompleteModalDisplay) {
            setIsCompleteQuestion(true);
          }
        }
      } else {
        setIsPopupOpen(true);
      }
    }
  };

  // Onchnage Radio and Checkboxes

  const handleOnChangeRadio = (e, labelName) => {
    if (!isAnswerGivenList[questionNo]) {
      const value = labelName ? labelName : e.target.value;

      setRadioValue(value);
      setAnswerOptions(prevOptions => ({
        ...prevOptions,
        [questionNo]: [{ optionText: value, isAnswer: 1 }]
      }));
      setIsAnswerGivenList(prevOptions => ({
        ...prevOptions,
        [questionNo]: true
      }));
    }
  };

  const handleCheckBoxAnswerGivenList = length => {
    const countIsAnswerOne = viewContent?.flashCard[
      questionNo - 1
    ]?.optionRequests?.filter(item => item.isAnswer === 1).length;

    if (countIsAnswerOne == length) {
      setIsAnswerGivenList(prevOptions => ({
        ...prevOptions,
        [questionNo]: true
      }));
    }
  };

  const handleOnChangeCheckbox = (e, labelName) => {
    if (!isAnswerGivenList[questionNo]) {
      setAnswerOptions(prevOptions => {
        const existingOption = prevOptions[questionNo].find(
          option => option.optionText === labelName
        );

        // If labelName exists, remove it; otherwise, add it
        const updatedOptions = existingOption
          ? prevOptions[questionNo].filter(
              option => option.optionText !== labelName
            )
          : [
              ...prevOptions[questionNo],
              { optionText: labelName, isAnswer: 1 }
            ];

        handleCheckBoxAnswerGivenList(updatedOptions.length);

        return {
          ...prevOptions,
          [questionNo]: updatedOptions
        };
      });
    }
  };

  // For Text to Speech

  const optionsForText = contentDetails?.flashCard[
    questionNo - 1
  ]?.optionRequests
    ?.map(item => item.optionText)
    .join(', ');

  const [isSeechClick, setIsSpeechClick] = useState(false);
  const [isHintSpeechClick, setIsHintSpeechClick] = useState(false);

  // const handleSpeechClick = () => {
  //   if (!isSeechClick) {
  //     setIsSpeechClick(true);
  //     const questionText =
  //       contentDetails?.flashCard[questionNo - 1]?.questionText;
  //     const optionsText = optionsForText;
  //     const description =
  //       contentDetails?.flashCard[questionNo - 1]?.description;

  //     let speechText = `Question is ${questionText}. Option is ${optionsText}.`;

  //     if (description) {
  //       speechText += ` Description is ${description}.`;
  //     }

  //     const utterance = new SpeechSynthesisUtterance(speechText);
  //     window.speechSynthesis.speak(utterance);
  //   } else {
  //     window.speechSynthesis.cancel();
  //     setIsSpeechClick(false);
  //   }
  // };

  const handleSpeechClick = () => {
    if (!isSeechClick) {
      setIsSpeechClick(true);

      const questionObj = contentDetails?.flashCard[questionNo - 1];
      const answerObj = questionObj?.optionRequests?.find(
        opt => opt.isAnswer === 1
      );
      const answerText = answerObj?.optionText;

      const questionText = questionObj?.questionText;
      const optionsText = optionsForText;
      const description = questionObj?.description;

      let speechText = '';

      if (isFlipped) {
        speechText = `The answer is: ${answerText || 'Not available'}.`;
      } else {
        if (questionObj?.questionType === 'textField') {
          speechText = `Question is: ${questionText}.`;
        } else {
          speechText = `Question is: ${questionText}. Option is: ${optionsText || 'No options available'}.`;
        }

        if (description) {
          speechText += ` Description is: ${description}`;
        }
      }

      const utterance = new SpeechSynthesisUtterance(speechText);
      window.speechSynthesis.speak(utterance);

      utterance.onend = () => {
        setIsSpeechClick(false);
      };
    } else {
      window.speechSynthesis.cancel();
      setIsSpeechClick(false);
    }
  };

  const handleHintSpeech = () => {
    if (!isHintSpeechClick) {
      setIsHintSpeechClick(true);
      const utterance = new SpeechSynthesisUtterance(
        `${contentDetails?.flashCard[questionNo - 1]?.hint}`
      );
      window.speechSynthesis.speak(utterance);
    } else {
      window.speechSynthesis.cancel();
      setIsHintSpeechClick(false);
    }
  };

  const handleFlip = () => {
    setIsAnswerGivenList(prevOptions => ({
      ...prevOptions,
      [questionNo]: true
    }));
    setIsFlipped(!isFlipped);
  };

  // Mapping Purpose and Find out the Answer

  const currentOptions = questionOptions[questionNo] || [];

  // For RadioButtons

  const correctAnswer = currentOptions.find(item => item.isAnswer === 1);

  const givenAnswer = answerOptions[questionNo] || {};

  // For CheckBoxes

  const correctCheckboxAnswers = currentOptions.filter(
    item => item.isAnswer === 1
  );

  const givenCheckboxAnswers = answerOptions[questionNo] || [];

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    const sortedArr1 = [...arr1].sort((a, b) =>
      a.optionText.localeCompare(b.optionText)
    );
    const sortedArr2 = [...arr2].sort((a, b) =>
      a.optionText.localeCompare(b.optionText)
    );
    return sortedArr1.every(
      (item, index) =>
        JSON.stringify(item) === JSON.stringify(sortedArr2[index])
    );
  };

  const handleCloseModal = () => {
    setIsCompleteQuestion(false);
  };

  const handleCloseImageModal = () => {
    setIsImageModalOpen(false);
  };

  useEffect(() => {
    if (sectionId) {
      if (basicDetails.gradeId) {
        getAllContentBySectionAPI();
      }
    }
  }, [sectionId, encryptId, searchTerm, isSaveToWatchLaterSuccess]);

  const getAllContentBySectionAPI = () => {
    if (path.includes('/content-space/library')) {
      const payload = {
        userId: authData?.userId,
        contentType: 'All',
        startDate: '',
        endDate: '',
        dateType: 'all',
        section: location?.state?.sectionId,
        encryptedContentId: isAutoPlay
          ? encryptIds.length === 1
            ? encryptId
            : encryptIds.join(',')
          : encryptId,
        paginationRequest: {
          type: 'all',
          page: 0,
          size: 20
        }
      };
      const search = searchTerm;
      dispatch(getLibraryListAll({ payload, search }));
    } else if (path.includes('/content-space/favourites')) {
      const payload = {
        userId: authData?.userId,
        contentType: 'All',
        startDate: location.state?.apiDate,
        endDate: location.state?.apiDate,
        dateType: 'selected_date',
        encryptedContentId: isAutoPlay
          ? encryptIds.length === 1
            ? encryptId
            : encryptIds.join(',')
          : encryptId,
        paginationRequest: {
          type: 'all',
          page: 0,
          size: 20
        }
      };
      const search = searchTerm;
      dispatch(getFavouriteListAll({ payload, search }));
    } else {
      let payload = {
        page: 0,
        size: 15,
        type: 'all'
      };
      let queryParam = {
        search: searchTerm || '',
        grade: basicDetails?.gradeId || '',
        sectionId: sectionId,
        userId: userId || 0,
        encryptedContentId: isAutoPlay
          ? encryptIds.length === 1
            ? encryptId
            : encryptIds.join(',')
          : encryptId,
        tags: tags ? tags.join(',') : ''
      };
      dispatch(getAllContentBySection({ payload, queryParam }));
    }
  };

  useEffect(() => {
    if (isUpdateLikeDislikeSuccess) {
      getAllContentBySectionAPI();
      // dispatch(getContentById({ encryptId, userId }));
      dispatch(getGamificationPoints(authData?.userId || 0));
    }
  }, [isUpdateLikeDislikeLoading, isUpdateLikeDislikeSuccess]);

  const handleAutoPlay = e => {
    let payload = {
      userId: userId || 0,
      autoPlayStatus: e?.target?.checked,
      loggedInUserName: userName || ''
    };
    dispatch(updateAutoPlayStatus({ payload }));
    setIsAutoPlay(e?.target?.checked);
    setIsAutoPlayStatus(e?.target?.checked);
  };

  const debouncedSearch = _.debounce(term => setSearchTerm(term), 300);

  const handleSearch = e => {
    const term = e.target.value;
    if (term.length >= 3 || term.length === 0) {
      debouncedSearch(term);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '10px'
        }}
      >
        <SvgIcon
          sx={{ marginRight: 2, cursor: 'pointer' }}
          onClick={() => navigate(-1)}
        >
          {BACK_ICON}
        </SvgIcon>

        <Typography
          sx={{
            fontSize: '32px',
            fontWeight: '700',
            color: colorTextBlack
          }}
        >
          {viewContent?.section || ''}
        </Typography>
      </Box>
      <Box
        sx={{
          marginBottom: 4,
          backgroundColor: '#FFFFFF',
          padding: '30px',
          borderRadius: '8px'
        }}
      >
        {/* Progress Bar , Time and Sound */}
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography
            style={{
              fontSize: '14px',
              lineHeight: '18px',
              fontWeight: 700,
              fontFamily: 'Lato',
              color: '#749E35',
              marginBottom: '-2px'
            }}
          >
            {Math.floor(percentageRemaining)} % Completed
          </Typography>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {/* Progress Bar */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <BorderLinearProgress
                  variant="determinate"
                  value={percentageRemaining || 0}
                  style={{ flexGrow: 1 }}
                />
                <div
                  style={{ display: 'flex', marginLeft: '-4px', zIndex: '10' }}
                >
                  <img
                    src={PROGRESS_STAR}
                    alt="ProgressStar"
                    style={{
                      width: '24px',
                      height: '24px'
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: '2px'
                }}
              >
                <Typography
                  style={{
                    fontSize: '12px',
                    lineHeight: '14px',
                    fontWeight: 700,
                    fontFamily: 'Lato',
                    color: colorTextGrey
                  }}
                >
                  {questionsRemaining} questions remaining
                </Typography>
              </div>
            </div>

            {/* Speech to Text */}

            <div
              style={{
                border: `2px solid ${colorPrimary}`,
                borderRadius: '6px',
                padding: '7px 7px 5px 7px',
                marginLeft: '12px',
                marginRight: '12px',
                cursor: 'pointer'
              }}
              onClick={handleSpeechClick}
            >
              <SvgIcon sx={{ height: '18px', width: '18px' }}>
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.9566 4.16726C18.1377 5.80912 18.8334 7.82362 18.8334 10.0006C18.8334 12.1776 18.1377 14.1921 16.9566 15.8339M13.6211 6.66726C14.2802 7.61212 14.6667 8.76122 14.6667 10.0006C14.6667 11.24 14.2802 12.3891 13.6211 13.3339M8.52862 3.63866L5.89054 6.27673C5.74642 6.42086 5.67436 6.49292 5.59026 6.54446C5.5157 6.59015 5.43441 6.62382 5.34938 6.64423C5.25347 6.66726 5.15156 6.66726 4.94774 6.66726H3.50002C3.03331 6.66726 2.79995 6.66726 2.62169 6.75809C2.46489 6.83798 2.33741 6.96546 2.25751 7.12227C2.16669 7.30052 2.16669 7.53388 2.16669 8.00059V12.0006C2.16669 12.4673 2.16669 12.7007 2.25751 12.8789C2.33741 13.0357 2.46489 13.1632 2.62169 13.2431C2.79995 13.3339 3.03331 13.3339 3.50002 13.3339H4.94774C5.15156 13.3339 5.25347 13.3339 5.34938 13.3569C5.43441 13.3774 5.5157 13.411 5.59026 13.4567C5.67436 13.5083 5.74642 13.5803 5.89054 13.7244L8.52862 16.3625C8.8856 16.7195 9.06409 16.898 9.21733 16.9101C9.3503 16.9205 9.48024 16.8667 9.56686 16.7653C9.66669 16.6484 9.66669 16.396 9.66669 15.8911V4.11007C9.66669 3.60522 9.66669 3.3528 9.56686 3.23591C9.48024 3.13449 9.3503 3.08067 9.21733 3.09113C9.06409 3.10319 8.8856 3.28168 8.52862 3.63866Z"
                    stroke="#1F2933"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </SvgIcon>
            </div>

            {/* Time */}

            {viewContent?.flashCard[questionNo - 1]?.questionType !==
              'textField' && (
              <div
                style={{
                  border: `2px solid ${isAnswerGivenList[questionNo] ? colorTextGrey : colorPrimary}`,
                  borderRadius: '6px',
                  padding: '7px 15px 7px 15px',
                  backgroundColor: isAnswerGivenList[questionNo]
                    ? colorDisableGrey
                    : '#FEF8EC',
                  cursor: isAnswerGivenList[questionNo]
                    ? 'not-allowed'
                    : 'pointer'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <SvgIcon sx={{ height: '20px', width: '20px' }}>
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.66663 2.5L2.16663 5M18.8333 5L16.3333 2.5M5.49996 15.8333L3.83329 17.5M15.5 15.8333L17.1666 17.5M10.5 7.5V10.8333L12.1666 12.5M10.5 17.5C12.2681 17.5 13.9638 16.7976 15.214 15.5474C16.4642 14.2971 17.1666 12.6014 17.1666 10.8333C17.1666 9.06522 16.4642 7.36953 15.214 6.11929C13.9638 4.86905 12.2681 4.16667 10.5 4.16667C8.73185 4.16667 7.03616 4.86905 5.78591 6.11929C4.53567 7.36953 3.83329 9.06522 3.83329 10.8333C3.83329 12.6014 4.53567 14.2971 5.78591 15.5474C7.03616 16.7976 8.73185 17.5 10.5 17.5Z"
                        stroke="#4E565F"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                  <Typography
                    style={{
                      fontSize: '14px',
                      fontWeight: 500,
                      fontFamily: 'Lato',
                      color: colorLinkGrey,
                      marginLeft: '8px'
                    }}
                  >
                    {isAnswerGivenList[questionNo] ? '00:00' : formatTime(time)}
                  </Typography>
                </div>
              </div>
            )}
          </Box>
        </Box>

        {/* Description and Image */}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '12px'
          }}
        >
          {viewContent?.flashCard[questionNo - 1]?.fileUrl && (
            <>
              <img
                src={viewContent?.flashCard[questionNo - 1]?.fileUrl || ''}
                alt="Image"
                style={{
                  width: '122px',
                  height: '81px',
                  borderRadius: '8px'
                }}
              />
              <div
                style={{
                  backgroundColor: '#EAF1FE',
                  borderRadius: '4px',
                  paddingTop: '2px',
                  paddingBottom: '3px',
                  paddingLeft: '5px',
                  paddingRight: '5px',
                  marginLeft: '-25px',
                  marginTop: '40px',
                  cursor: 'pointer'
                }}
                onClick={() => setIsImageModalOpen(true)}
              >
                <SvgIcon sx={{ height: '10px', width: '10px' }}>
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.66667 3.33333L7 1M7 1H5M7 1V3M3.33333 4.66667L1 7M1 7H3M1 7L1 5"
                      stroke="#1F2933"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SvgIcon>
              </div>
            </>
          )}

          {viewContent?.flashCard[questionNo - 1]?.description && (
            <Typography
              style={{
                width: '100%',
                fontSize: '20px',
                fontWeight: 700,
                fontFamily: 'Lato',
                lineHeight: '26px',
                color: colorLinkGrey,
                marginLeft:
                  viewContent?.flashCard[questionNo - 1]?.fileUrl && '40px'
              }}
            >
              {viewContent?.flashCard[questionNo - 1]?.description || ''}
            </Typography>
          )}
        </div>
        {/* Questions and Answers */}

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '12px'
          }}
        >
          {viewContent?.flashCard[questionNo - 1]?.questionType !==
            'textField' && (
            <Typography
              style={{
                fontSize: '28px',
                lineHeight: '34px',
                fontWeight: 600,
                fontFamily: 'Lato',
                color: colorTextBlack
              }}
            >
              {viewContent?.flashCard[questionNo - 1]?.questionText || ''}
            </Typography>
          )}

          {viewContent?.flashCard[questionNo - 1]?.questionType ==
            'singleChoice' && (
            <Typography
              style={{
                fontSize: '16px',
                lineHeight: '20px',
                fontWeight: 600,
                fontFamily: 'Lato',
                color: isAnswerGivenList[questionNo]
                  ? correctAnswer?.optionText == givenAnswer[0]?.optionText
                    ? colorTextBlack
                    : ' #EA7804'
                  : colorTextBlack,
                marginTop: '20px'
              }}
            >
              {isAnswerGivenList[questionNo]
                ? correctAnswer?.optionText == givenAnswer[0]?.optionText
                  ? 'Your answer is correct, go for more!'
                  : 'No sweat, you are still learning!'
                : 'Choose correct answer'}
            </Typography>
          )}

          {viewContent?.flashCard[questionNo - 1]?.questionType ==
            'multipleChoice' && (
            <Typography
              style={{
                fontSize: '16px',
                lineHeight: '20px',
                fontWeight: 600,
                fontFamily: 'Lato',
                color: isAnswerGivenList[questionNo]
                  ? areArraysEqual(correctCheckboxAnswers, givenCheckboxAnswers)
                    ? colorTextBlack
                    : ' #EA7804'
                  : colorTextBlack,
                marginTop: '20px'
              }}
            >
              {isAnswerGivenList[questionNo]
                ? areArraysEqual(correctCheckboxAnswers, givenCheckboxAnswers)
                  ? 'Your answer is correct, go for more!'
                  : 'No sweat, you are still learning!'
                : 'Choose correct answer'}
            </Typography>
          )}

          {viewContent?.flashCard[questionNo - 1]?.questionType ==
          'singleChoice' ? (
            <div style={{ marginTop: '20px', width: '70%' }}>
              <RadioGroup value={radioValue} onChange={handleOnChangeRadio}>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '15px'
                  }}
                >
                  {currentOptions?.map((item, index) => {
                    return (
                      <div
                        style={{
                          display: 'flex',
                          border:
                            isAnswerGivenList[questionNo] &&
                            correctAnswer?.optionText == item.optionText
                              ? `1px dotted #749E35`
                              : isAnswerGivenList[questionNo] &&
                                  givenAnswer[0]?.optionText == item.optionText
                                ? `1px solid #D62828`
                                : `1px solid ${colorDisableGrey}`,
                          borderRadius: '8px',
                          alignItems: 'center',
                          backgroundColor:
                            isAnswerGivenList[questionNo] &&
                            correctAnswer?.optionText == item.optionText &&
                            `#EBF9D9`,
                          cursor: 'pointer'
                        }}
                        onClick={e => handleOnChangeRadio(e, item.optionText)}
                        key={index}
                      >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Radio
                            value={item.optionText}
                            sx={{
                              color: colorTextGrey,
                              '&.Mui-checked': {
                                color: colorPrimary
                              }
                            }}
                            id={item.optionText}
                          />

                          <Typography
                            style={{
                              fontSize: '14px',
                              fontWeight: 500,
                              lineHeight: '18px',
                              fontFamily: 'Lato',
                              color: colorLinkGrey
                            }}
                          >
                            {item.optionText}
                          </Typography>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </RadioGroup>
            </div>
          ) : viewContent?.flashCard[questionNo - 1]?.questionType ==
            'multipleChoice' ? (
            <div style={{ marginTop: '20px', width: '70%' }}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  rowGap: '8px',
                  columnGap: '15px'
                }}
              >
                {currentOptions?.map((item, index) => {
                  const answerList = answerOptions[questionNo].map(
                    item => item.optionText
                  );
                  const isOptionPresentInCorrectAnswer =
                    correctCheckboxAnswers?.some(
                      ele => ele.optionText == item.optionText
                    );

                  const isOptionPresentInGivenAnswer =
                    givenCheckboxAnswers?.some(
                      ele => ele.optionText == item.optionText
                    );

                  return (
                    <div
                      style={{
                        display: 'flex',
                        border:
                          isAnswerGivenList[questionNo] &&
                          isOptionPresentInCorrectAnswer
                            ? `1px dotted #749E35`
                            : isAnswerGivenList[questionNo] &&
                                !isOptionPresentInCorrectAnswer &&
                                isOptionPresentInGivenAnswer
                              ? `1px solid #D62828`
                              : `1px solid ${colorDisableGrey}`,
                        borderRadius: '8px',
                        alignItems: 'center',
                        marginTop: '10px',
                        justifyContent: 'space-between',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        cursor: 'pointer',
                        backgroundColor:
                          isAnswerGivenList[questionNo] &&
                          isOptionPresentInCorrectAnswer &&
                          `#EBF9D9`
                      }}
                      onClick={e => handleOnChangeCheckbox(e, item.optionText)}
                      key={index}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox
                          size="small"
                          checked={answerList.includes(item.optionText)}
                          style={{ marginRight: '5px' }}
                          onChange={e => {
                            e.stopPropagation();
                            handleOnChangeCheckbox(e, item.optionText);
                          }}
                          onClick={e => e.stopPropagation()}
                        />

                        <Typography
                          style={{
                            fontSize: '14px',
                            fontWeight: 500,
                            lineHeight: '18px',
                            fontFamily: 'Lato',
                            color: colorLinkGrey
                          }}
                        >
                          {item.optionText}
                        </Typography>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : viewContent?.flashCard[questionNo - 1]?.questionType ==
            'textField' ? (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: '18vw',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.5s',
                  transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
                  transformStyle: 'preserve-3d'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
                  }}
                >
                  <Typography
                    style={{
                      fontSize: '28px',
                      lineHeight: '34px',
                      fontWeight: 600,
                      fontFamily: 'Lato',
                      color: colorTextBlack
                    }}
                  >
                    {isFlipped
                      ? viewContent?.flashCard[questionNo - 1]
                          ?.optionRequests[0].optionText || ''
                      : viewContent?.flashCard[questionNo - 1]?.questionText ||
                        ''}
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '-50px'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: colorPrimary,
                    width: '86px',
                    height: '36px',
                    borderRadius: '8px',
                    alignItems: 'center',
                    cursor: 'pointer'
                  }}
                  className="glowing-div"
                  onClick={handleFlip}
                >
                  <SvgIcon sx={{ height: '15px', width: '15px' }}>
                    <svg
                      width="15"
                      height="14"
                      viewBox="0 0 15 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3337 5.83333H1.66699M6.91699 11.0833L11.467 11.0833C12.1204 11.0833 12.4471 11.0833 12.6966 10.9562C12.9162 10.8443 13.0946 10.6658 13.2065 10.4463C13.3337 10.1968 13.3337 9.87006 13.3337 9.21667V4.78333C13.3337 4.12994 13.3337 3.80324 13.2065 3.55368C13.0946 3.33416 12.9162 3.15568 12.6966 3.04383C12.4471 2.91667 12.1204 2.91667 11.467 2.91667H10.417M6.91699 11.0833L8.08366 12.25M6.91699 11.0833L8.08366 9.91667M4.58366 11.0833H3.53366C2.88026 11.0833 2.55357 11.0833 2.304 10.9562C2.08448 10.8443 1.906 10.6658 1.79415 10.4463C1.66699 10.1968 1.66699 9.87006 1.66699 9.21667V4.78333C1.66699 4.12994 1.66699 3.80324 1.79415 3.55368C1.906 3.33416 2.08448 3.15568 2.304 3.04383C2.55357 2.91667 2.88026 2.91667 3.53366 2.91667H8.08366M8.08366 2.91667L6.91699 4.08333M8.08366 2.91667L6.91699 1.75"
                        stroke="#1F2933"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                  <Typography
                    style={{
                      fontSize: '12px',
                      lineHeight: '14px',
                      fontWeight: 700,
                      fontFamily: 'Lato',
                      color: colorTextBlack,
                      marginLeft: '5px'
                    }}
                  >
                    Flip
                  </Typography>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>

        {/* Hint */}
        {viewContent?.flashCard[questionNo - 1]?.hint && (
          <>
            {isShowHint ? (
              <div
                style={{
                  display: 'flex',
                  backgroundColor: '#EBF9D9',
                  alignItems: 'center',
                  padding: '10px',
                  justifyContent: 'space-between',
                  marginTop: '5rem',
                  borderRadius: '8px'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography
                    style={{
                      fontSize: '20px',
                      lineHeight: '26px',
                      fontWeight: 700,
                      fontFamily: 'Lato',
                      color: colorTextBlack,
                      marginRight: '10px'
                    }}
                  >
                    Hint:
                  </Typography>
                  <SvgIcon
                    sx={{ height: '18px', width: '18px', cursor: 'pointer' }}
                    onClick={handleHintSpeech}
                  >
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.9566 4.16726C18.1377 5.80912 18.8334 7.82362 18.8334 10.0006C18.8334 12.1776 18.1377 14.1921 16.9566 15.8339M13.6211 6.66726C14.2802 7.61212 14.6667 8.76122 14.6667 10.0006C14.6667 11.24 14.2802 12.3891 13.6211 13.3339M8.52862 3.63866L5.89054 6.27673C5.74642 6.42086 5.67436 6.49292 5.59026 6.54446C5.5157 6.59015 5.43441 6.62382 5.34938 6.64423C5.25347 6.66726 5.15156 6.66726 4.94774 6.66726H3.50002C3.03331 6.66726 2.79995 6.66726 2.62169 6.75809C2.46489 6.83798 2.33741 6.96546 2.25751 7.12227C2.16669 7.30052 2.16669 7.53388 2.16669 8.00059V12.0006C2.16669 12.4673 2.16669 12.7007 2.25751 12.8789C2.33741 13.0357 2.46489 13.1632 2.62169 13.2431C2.79995 13.3339 3.03331 13.3339 3.50002 13.3339H4.94774C5.15156 13.3339 5.25347 13.3339 5.34938 13.3569C5.43441 13.3774 5.5157 13.411 5.59026 13.4567C5.67436 13.5083 5.74642 13.5803 5.89054 13.7244L8.52862 16.3625C8.8856 16.7195 9.06409 16.898 9.21733 16.9101C9.3503 16.9205 9.48024 16.8667 9.56686 16.7653C9.66669 16.6484 9.66669 16.396 9.66669 15.8911V4.11007C9.66669 3.60522 9.66669 3.3528 9.56686 3.23591C9.48024 3.13449 9.3503 3.08067 9.21733 3.09113C9.06409 3.10319 8.8856 3.28168 8.52862 3.63866Z"
                        stroke="#1F2933"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                  <Typography
                    style={{
                      fontSize: '16px',
                      lineHeight: '20px',
                      fontWeight: 600,
                      fontFamily: 'Lato',
                      color: colorTextBlack,
                      marginLeft: '10px'
                    }}
                  >
                    {viewContent?.flashCard[questionNo - 1]?.hint || ''}
                  </Typography>
                </div>

                <div style={{ cursor: 'pointer' }}>
                  <SvgIcon
                    sx={{
                      height: '12px',
                      width: '12px',
                      marginRight: '10px',
                      cursor: 'pointer'
                    }}
                    onClick={() => setIsShowHint(false)}
                  >
                    <svg
                      width="10"
                      height="9"
                      viewBox="0 0 10 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.33366 1.16797L1.66699 7.83464M1.66699 1.16797L8.33366 7.83464"
                        stroke="#4E565F"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                </div>
              </div>
            ) : (
              <div
                style={{
                  border: `2px solid ${colorPrimary}`,
                  borderRadius: '8px',
                  padding: '7px 15px 7px 15px',
                  width: '90px',
                  marginTop: '5rem',
                  cursor: 'pointer'
                }}
                onClick={() => setIsShowHint(true)}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <SvgIcon sx={{ height: '20px', width: '20px' }}>
                    <svg
                      width="15"
                      height="14"
                      viewBox="0 0 15 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33334 10.3021V11.668C6.33334 12.3123 6.85567 12.8346 7.5 12.8346C8.14434 12.8346 8.66667 12.3123 8.66667 11.668V10.3021M7.5 1.16797V1.7513M2.25001 7.0013H1.66667M3.70834 3.20964L3.35828 2.85958M11.2917 3.20964L11.6418 2.85958M13.3333 7.0013H12.75M11 7.0013C11 8.9343 9.433 10.5013 7.5 10.5013C5.56701 10.5013 4.00001 8.9343 4.00001 7.0013C4.00001 5.06831 5.56701 3.5013 7.5 3.5013C9.433 3.5013 11 5.06831 11 7.0013Z"
                        stroke="#1F2933"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                  <Typography
                    style={{
                      fontSize: '14px',
                      fontWeight: 700,
                      fontFamily: 'Lato',
                      lineHeight: '14px',
                      color: colorTextBlack,
                      marginLeft: '8px'
                    }}
                  >
                    Hint
                  </Typography>
                </div>
              </div>
            )}
          </>
        )}

        {/* Pagination arrow */}
        <div
          style={{
            display: 'flex',
            marginTop: '15px',
            justifyContent: 'flex-end'
          }}
        >
          <div
            style={{
              borderRadius: '4px',
              backgroundColor: '#F5F7FA',
              padding: '5px 5px 5px 5px',
              marginRight: '15px',
              cursor: 'pointer'
            }}
            onClick={() => handleQuestionNo('back')}
          >
            <SvgIcon sx={{ height: '20px', width: '20px' }}>
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 15L8 10L13 5"
                  stroke={questionNo == 1 ? '#CBD2D9' : '#1F2933'}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </SvgIcon>
          </div>
          <div
            style={{
              borderRadius: '4px',
              backgroundColor: '#F5F7FA',
              padding: '5px 5px 5px 5px',
              cursor: 'pointer'
            }}
            onClick={() => handleQuestionNo('forward')}
          >
            <SvgIcon sx={{ height: '20px', width: '20px' }}>
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 15L13 10L8 5"
                  stroke={
                    questionNo - 1 == viewContent?.flashCard.length - 1 &&
                    isCompleteModalDisplay
                      ? '#CBD2D9'
                      : '#1F2933'
                  }
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </SvgIcon>
          </div>
        </div>
      </Box>

      {/* Pop up Message */}
      {isPopupOpen && (
        <Dialog open={isPopupOpen}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              // marginTop: '-2.8rem',
              zIndex: 1000
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '20px',
                backgroundColor: '#FFFFFF',
                borderRadius: '8px',
                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)'
                // position: 'relative'
              }}
            >
              {/* The arrow */}
              <div
                style={{
                  // position: 'absolute',
                  top: '-10px', // Position the arrow above the modal
                  left: '85%',
                  transform: 'translateX(-50%)',
                  width: '0',
                  height: '0',
                  borderLeft: '10px solid transparent',
                  borderRight: '10px solid transparent',
                  borderBottom: '10px solid #FFFFFF'
                }}
              />

              <Typography
                style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  lineHeight: '26px',
                  fontFamily: 'Lato',
                  color: colorTextBlack
                }}
              >
                Note:
              </Typography>
              <Typography
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '18px',
                  fontFamily: 'Lato',
                  color: '#00000099',
                  marginTop: '1rem'
                }}
              >
                {viewContent?.flashCard[questionNo - 1]?.questionType ==
                'textField'
                  ? 'Please click the Flip button first, then click Next.'
                  : 'Please select the correct answer first, then click Next.'}
              </Typography>

              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  size="small"
                  color="primary"
                  variant="contained"
                  sx={{
                    borderColor: colorPrimary,
                    borderRadius: '10px',
                    color: colorTextBlack,
                    borderWidth: '2px',
                    height: '32px',
                    width: '46px',
                    marginTop: '1rem'
                  }}
                  onClick={() => setIsPopupOpen(false)}
                >
                  Ok
                </Button>
              </div>
            </div>
          </div>
        </Dialog>
      )}

      {/* FlashCard Description */}

      <div style={{ display: 'flex', marginTop: '10px' }}>
        <Typography
          style={{
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: '32px',
            fontFamily: 'Lato',
            color: colorTextBlack
          }}
        >
          {viewContent?.title || ''}
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'end',
          marginTop: '20px'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            {viewContent?.profileImageUrl ? (
              <Avatar
                src={viewContent?.profileImageUrl || ''}
                alt={viewContent?.profileImageUrl || ''}
                sx={{ width: 44, height: 44, marginRight: 1 }}
              />
            ) : (
              <div style={circleStyle}>
                {viewContent
                  ? viewContent?.userName?.split(' ')[0].charAt(0).toUpperCase()
                  : 'A'}
              </div>
            )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              style={{
                fontSize: '16px',
                fontWeight: 700,
                lineHeight: '20px',
                fontFamily: 'Lato',
                color: colorLinkGrey,
                marginLeft: '5px'
              }}
            >
              {viewContent?.userName || ''}
            </Typography>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '10px' }}>
        <Divider />
      </div>

      <Typography
        style={{
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '18px',
          fontFamily: 'Lato',
          color: colorLinkGrey,
          marginTop: '10px'
        }}
      >
        {viewContent?.description || ''}
      </Typography>

      {/* Recommended contents */}

      <Box
        sx={{
          marginBottom: 4,
          backgroundColor: '#FFFFFF',
          padding: '15px',
          borderRadius: '8px',
          marginTop: '20px'
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Typography
              style={{
                fontSize: '20px',
                fontWeight: 700,
                lineHeight: '26px',
                fontFamily: 'Lato',
                color: colorTextBlack
              }}
            >
              More classes
            </Typography>

            <Search>
              <SearchIconWrapper>
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 17.5L14.375 13.875M16.3333 9.16667C16.3333 12.8486 13.3486 15.8333 9.66667 15.8333C5.98477 15.8333 3 12.8486 3 9.16667C3 5.48477 5.98477 2.5 9.66667 2.5C13.3486 2.5 16.3333 5.48477 16.3333 9.16667Z"
                    stroke="#ABB4BD"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </SearchIconWrapper>
              <StyledInputBase
                onChange={e => {
                  searchValue = e.target.value;
                  handleSearch(e);
                }}
                placeholder="Search here…"
              />
            </Search>
          </div>

          <FormControlLabel
            sx={{
              marginTop: '10px',
              marginBottom: '20px',
              color: colorLinkGrey,
              '& .MuiFormControlLabel-label': {
                color: colorLinkGrey,
                fontSize: '14px',
                lineHeight: '18px',
                fontWeight: '600',
                marginLeft: '1rem'
              },
              width: '20%'
            }}
            control={<IOSSwitch />}
            checked={isAutoPlay}
            onChange={e => handleAutoPlay(e)}
            label={isAutoPlay ? 'Autoplay is on' : 'Autoplay is off'}
            labelPlacement="end"
          />

          {isSectionWiseContentLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress />
            </div>
          ) : !isSectionWiseContentLoading && contentList.length > 0 ? (
            <div
              style={{
                display: 'flex',
                overflowX: 'auto',
                paddingBottom: '16px'
              }}
            >
              <Grid
                container
                spacing={2}
                direction="row"
                style={{ flexWrap: 'nowrap' }}
              >
                {contentList?.map((video, index) => (
                  <Grid item xs={3} key={index} style={{ flex: '0 0 auto' }}>
                    <ContentCard
                      video={video}
                      sectionId={sectionId}
                      tags={tags}
                      path={path || ''}
                    />
                  </Grid>
                ))}
              </Grid>
            </div>
          ) : (
            <Box
              sx={{
                marginBottom: 4,
                backgroundColor: '#FFFFFF',
                padding: '16px',
                borderRadius: '8px',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Typography
                style={{
                  fontFamily: 'Lato',
                  fontSize: '14px',
                  fontWeight: 700,
                  color: colorTextGrey
                }}
              >
                No content available
              </Typography>
            </Box>
          )}
        </div>
      </Box>

      {/* <button onClick={handleButtonClick}>Start Speaking</button> */}

      <QuestionCompleteModal
        isOpen={isCompleteQuestion}
        handleClose={handleCloseModal}
      />

      <FlashcardImageModal
        image={viewContent?.flashCard[questionNo - 1]?.fileUrl || ''}
        isOpen={imageModalOpen}
        handleClose={handleCloseImageModal}
      />
    </>
  );
};

export default FlashCardView;
